// extracted by mini-css-extract-plugin
module.exports = {"container":"tournamentName__container___3p-ro","name":"tournamentName__name___efC3D"};